<template>
  <v-container fluid class="d-flex justify-center flex-wrap">
    <header-card v-for="child in children" :key="child.name" :node="child" :class="setOldGuiCssClass(child)">
    </header-card>
  </v-container>
</template>


<script>
import HeaderCard from "@/components/Cards/HeaderCard.vue";
import NavMixin from "@/helpers/Mixins/NavMixin";

export default {
  name: "HeaderCardsContainer",
  components: { HeaderCard },
  mixins: [NavMixin],

  data() {
    return {
      children: null,
    };
  },

  mounted() {
    this.getChildren();
  },

  methods: {
    getChildren() {
      var cr = this.$route;
      var parent = cr.matched.at(-2);
      //console.log('cr', cr, 'parent', parent);
      var siblings = [];
      const parentName = parent.name;
      const routes = this.$router.getRoutes();
      siblings = routes.filter((x) => (
        x.parent?.name == parentName &&
        this.checkIfLicencedByKey(x.meta.licenceEnabled) &&
        this.checkIfFeatureEnabledByKey(x.meta.featureEnabled)
      ));
      this.children = siblings;
    },

    setOldGuiCssClass(node) {
      if (process.env.NODE_ENV === 'production' && this.$store.state.GlobalSettings.IsSaasMode && node.component?.name?.includes("OldGuiFrame")) {
        return "hidden"
      } else if (process.env.NODE_ENV === 'development' && node.component?.name?.includes("OldGuiFrame")) {
        return "oldgui-menu"
      }
      return "";
    }
  },

  watch: {
    $route: function () {
      this.getChildren();
    },
  },
};
</script>

<style lang="scss" scoped>
.oldgui-menu {
  border: 5px solid purple;
}
</style>